import { Checkbox } from '@rebass/forms'

import { SStyled } from 'styles/theme'

export const StyledCheckbox = SStyled(Checkbox)`
    ${(p) => `
    @media screen and (max-width: ${p.theme.breakpoints[3]}) {
        margin-right: 15px;
    }
    `}
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            margin-right: 7px;
            width: 45px;
            height: 45px;
        }
    `}
`
